var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-my-tree-select-field",
    _vm._g(
      _vm._b(
        {
          attrs: {
            form: _vm.form,
            name: _vm.name,
            title: _vm.title,
            options: _vm.tree.root.children,
            required: _vm.required,
          },
          on: { input: _vm.input },
        },
        "vue-my-tree-select-field",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }